import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

export default class DIApi extends BaseAPI {
  apiName = 'DI';

  /**
   * Theo dõi/Ngưng theo dõi
   * NXCHIEN 15.04.2022
   */
  quickUpdateFollowState(param) {
    let request = {
      url: this.getAPIUrl() + '/followState',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}
